import React from "react";
import useSearchParam from "hooks/useSearchParam";
import {useLangParamPreselect} from "hooks/useLangParamPreselect";
import SignUpEmail from "view/SignUp/SignUpEmail";

const SignUpPage = () => {
  const token = useSearchParam("token");
  useLangParamPreselect();
  if (token) {
    return <SignUpEmail />;
  }
  return null;
};

export default SignUpPage;
